import { defineSlotRecipe } from '@chakra-ui/react';
import { Colors, Radii, Space } from '../../types';

export const progressSlotRecipe = defineSlotRecipe({
  slots: ['root', 'track', 'range', 'label', 'valueText'],
  base: {
    // An unset `colorPalette` would fall through to Chakra's stock `gray`, whose `solid` step is near-black;
    // this design system's `neutral` resolves the same in both modes.
    root: {
      colorPalette: 'neutral',
    },
    range: {
      height: '100%',
      borderRadius: 0,
    },
    track: {
      overflow: 'hidden',
      bgColor: Colors.SURFACE_NEUTRAL_SUBDUED,
      borderRadius: Radii.SM,
      outline: '1px solid',
      outlineColor: Colors.BORDER_SUBDUED,
      outlineOffset: '-1px',
    },
  },
  variants: {
    // Must live on stock's active `outline` variant, not `base`: variant styles outrank base.
    variant: {
      outline: {
        range: {
          bgColor: 'colorPalette.400',
        },
      },
    },
    size: {
      xs: { track: { h: Space.SPACE_1 } },
      // `h` resolves against `sizes`, which has no `1_5` key, so Space.SPACE_1_5 would emit invalid CSS and a
      // 0-height track; reference the spacing var directly.
      sm: { track: { h: 'var(--udl-spacing-1_5)' } },
      md: { track: { h: Space.SPACE_2 } },
      lg: { track: { h: Space.SPACE_4 } },
    },
    striped: {
      true: {
        range: {
          backgroundImage:
            'linear-gradient(45deg, var(--stripe-color) 25%, transparent 25%, transparent 50%, var(--stripe-color) 50%, var(--stripe-color) 75%, transparent 75%, transparent)',
          backgroundSize: 'var(--stripe-size) var(--stripe-size)',
          '--stripe-size': '1rem',
          '--stripe-color': {
            _light: 'rgba(255, 255, 255, 0.3)',
            _dark: 'rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    animated: {
      true: {
        range: {
          '--animate-from': 'var(--stripe-size)',
          animation: 'bg-position 1s linear infinite',
        },
      },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});
